function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 10,
  cy: 10,
  r: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Current",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "3.1-VotingPeoples-Big-sidebar-+-Flow",
  transform: "translate(-21.000000, -170.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sidebar-/-Opened"
}, /*#__PURE__*/React.createElement("g", {
  id: "User-block",
  transform: "translate(0.000000, 155.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-/-ic_user-/-Act",
  transform: "translate(21.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("circle", {
  stroke: "#67D4B8",
  strokeWidth: 0.8,
  cx: 10,
  cy: 10,
  r: 9.6
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  mask: "url(#mask-2)",
  fill: "#67D4B8",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.750000, 4.083333)",
  id: "Combined-Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.25,19.4166667 C10.2875661,19.4166667 12.75,16.9542328 12.75,13.9166667 C12.75,10.8791005 10.2875661,8.41666667 7.25,8.41666667 C4.21243388,8.41666667 1.75,10.8791005 1.75,13.9166667 C1.75,16.9542328 4.21243388,19.4166667 7.25,19.4166667 Z M7.25,20.4166667 C3.66014913,20.4166667 0.75,17.5065175 0.75,13.9166667 C0.75,10.3268158 3.66014913,7.41666667 7.25,7.41666667 C10.8398509,7.41666667 13.75,10.3268158 13.75,13.9166667 C13.75,17.5065175 10.8398509,20.4166667 7.25,20.4166667 Z M7.25,7.41666667 C8.81480679,7.41666667 10.0833333,6.14814012 10.0833333,4.58333333 C10.0833333,3.01852654 8.81480679,1.75 7.25,1.75 C5.68519321,1.75 4.41666667,3.01852654 4.41666667,4.58333333 C4.41666667,6.14814012 5.68519321,7.41666667 7.25,7.41666667 Z M7.25,8.41666667 C5.13290846,8.41666667 3.41666667,6.70042487 3.41666667,4.58333333 C3.41666667,2.46624179 5.13290846,0.75 7.25,0.75 C9.36709154,0.75 11.0833333,2.46624179 11.0833333,4.58333333 C11.0833333,6.70042487 9.36709154,8.41666667 7.25,8.41666667 Z"
})))))))));

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.708cc2e0.svg";
export { ForwardRef as ReactComponent };